export default __webpack_public_path__ + "static/media/TokiRGB_paleBlue.846db45f.png";